function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("polygon", {
  points: "67.1,96.6 3.5,96.6 3.5,33 28.3,33 28.3,33 30.3,33 30.3,29.9 28.3,29.9 0.4,29.9 0.4,99.7 70.2,99.7 70.2,73.6  67.1,73.6  "
});

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 33.4,
  y: 29.9,
  width: 3.9,
  height: 3.1
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 40.4,
  y: 29.9,
  width: 3.9,
  height: 3.1
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "51.3,33 67.1,33 67.1,52.7 70.2,52.7 70.2,29.9 51.2,29.9 47.4,29.9 47.4,33 51.3,33  "
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "51.2,40 51.2,40 60.1,40 60.1,52.7 63.2,52.7 63.2,36.9 51.3,36.9 51.3,36.9 47.4,36.9 47.4,40  "
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 40.4,
  y: 36.9,
  width: 3.9,
  height: 3.1
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "60.1,89.6 10.5,89.6 10.5,40 28.3,40 28.3,40 30.3,40 30.3,36.9 28.3,36.9 28.3,36.9 7.4,36.9 7.4,92.7 63.2,92.7  63.2,73.6 60.1,73.6  "
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 33.4,
  y: 36.9,
  width: 3.9,
  height: 3.1
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 33.4,
  y: 43.9,
  width: 3.9,
  height: 3.1
});

var _ref10 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "51.2,43.9 47.4,43.9 47.4,47 53.1,47 53.1,52.7 56.2,52.7 56.2,43.9  "
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 40.4,
  y: 43.9,
  width: 3.9,
  height: 3.1
});

var _ref12 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "53.1,82.6 17.5,82.6 17.5,47 30.3,47 30.3,43.9 28.3,43.9 14.4,43.9 14.4,85.7 56.2,85.7 56.2,73.6 53.1,73.6  "
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 44.3,
  y: 47,
  width: 3.1,
  height: 0
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 63.2,
  y: 52.7,
  width: 3.9,
  height: 3.1
});

var _ref15 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "47.4,52.7 47.4,51 44.3,51 44.3,55.8 50.2,55.8 50.2,55.8 53.1,55.8 53.1,52.7  "
});

var _ref16 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "47.4,17.1 83,17.1 83,52.7 70.2,52.7 70.2,55.8 72.2,55.8 72.2,55.8 86.1,55.8 86.1,14 44.3,14 44.3,26.9  47.4,26.9  "
});

var _ref17 =
/*#__PURE__*/
React.createElement("rect", {
  x: 56.2,
  y: 52.7,
  width: 3.9,
  height: 3.1
});

var _ref18 =
/*#__PURE__*/
React.createElement("rect", {
  x: 67.1,
  y: 52.7,
  width: 3.1,
  height: 3.1
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 44.3,
  y: 29.9,
  width: 3.1,
  height: 3.1
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 60.1,
  y: 52.7,
  width: 3.1,
  height: 3.1
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 44.3,
  y: 36.9,
  width: 3.1,
  height: 3.1
});

var _ref22 =
/*#__PURE__*/
React.createElement("rect", {
  x: 53.1,
  y: 52.7,
  width: 3.1,
  height: 3.1
});

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 44.3,
  y: 43.9,
  width: 3.1,
  height: 3.1
});

var _ref24 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "50.2,66.7 33.4,66.7 33.4,51 30.3,51 30.3,69.8 50.2,69.8 50.2,69.8 53.1,69.8 53.1,66.7 50.2,66.7  "
});

var _ref25 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "100.1,0 30.3,0 30.3,26.9 33.4,26.9 33.4,3.1 97,3.1 97,66.7 72.2,66.7 72.2,66.7 70.2,66.7 70.2,69.8 72.2,69.8  72.2,69.8 100.1,69.8  "
});

var _ref26 =
/*#__PURE__*/
React.createElement("rect", {
  x: 56.2,
  y: 66.7,
  width: 3.9,
  height: 3.1
});

var _ref27 =
/*#__PURE__*/
React.createElement("rect", {
  x: 63.2,
  y: 66.7,
  width: 3.9,
  height: 3.1
});

var _ref28 =
/*#__PURE__*/
React.createElement("rect", {
  x: 31.9,
  y: 45.4,
  width: 0,
  height: 3.1
});

var _ref29 =
/*#__PURE__*/
React.createElement("rect", {
  x: 67.1,
  y: 66.7,
  width: 3.1,
  height: 3.1
});

var _ref30 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30.3,
  y: 29.9,
  width: 3.1,
  height: 3.1
});

var _ref31 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30.3,
  y: 36.9,
  width: 3.1,
  height: 3.1
});

var _ref32 =
/*#__PURE__*/
React.createElement("rect", {
  x: 60.1,
  y: 66.7,
  width: 3.1,
  height: 3.1
});

var _ref33 =
/*#__PURE__*/
React.createElement("rect", {
  x: 53.1,
  y: 66.7,
  width: 3.1,
  height: 3.1
});

var _ref34 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30.3,
  y: 43.9,
  width: 3.1,
  height: 3.1
});

var _ref35 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "50.2,59.7 40.4,59.7 40.4,51 37.3,51 37.3,62.8 50.2,62.8 50.2,62.8 53.1,62.8 53.1,59.7 50.2,59.7  "
});

var _ref36 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "40.4,10.1 90,10.1 90,59.7 72.2,59.7 72.2,59.7 70.2,59.7 70.2,62.8 72.2,62.8 72.2,62.8 93.1,62.8 93.1,7 37.3,7  37.3,26.9 40.4,26.9  "
});

var _ref37 =
/*#__PURE__*/
React.createElement("rect", {
  x: 56.2,
  y: 59.7,
  width: 3.9,
  height: 3.1
});

var _ref38 =
/*#__PURE__*/
React.createElement("rect", {
  x: 63.2,
  y: 59.7,
  width: 3.9,
  height: 3.1
});

var _ref39 =
/*#__PURE__*/
React.createElement("rect", {
  x: 37.3,
  y: 47,
  width: 3.1,
  height: 0
});

var _ref40 =
/*#__PURE__*/
React.createElement("rect", {
  x: 67.1,
  y: 59.7,
  width: 3.1,
  height: 3.1
});

var _ref41 =
/*#__PURE__*/
React.createElement("rect", {
  x: 37.3,
  y: 29.9,
  width: 3.1,
  height: 3.1
});

var _ref42 =
/*#__PURE__*/
React.createElement("rect", {
  x: 37.3,
  y: 36.9,
  width: 3.1,
  height: 3.1
});

var _ref43 =
/*#__PURE__*/
React.createElement("rect", {
  x: 60.1,
  y: 59.7,
  width: 3.1,
  height: 3.1
});

var _ref44 =
/*#__PURE__*/
React.createElement("rect", {
  x: 53.1,
  y: 59.7,
  width: 3.1,
  height: 3.1
});

var _ref45 =
/*#__PURE__*/
React.createElement("rect", {
  x: 37.3,
  y: 43.9,
  width: 3.1,
  height: 3.1
});

var SvgCollaboration = function SvgCollaboration(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), React.createElement("g", null, React.createElement("rect", {
    x: 42.3,
    y: 45,
    style: {
      fill: "none"
    },
    width: 0,
    height: 3.9
  }), React.createElement("rect", {
    x: 35.4,
    y: 45,
    style: {
      fill: "none"
    },
    width: 0,
    height: 3.9
  }), React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "51.2,47 51.2,51 47.4,51 47.4,52.7 53.1,52.7 53.1,47 47.4,47 47.4,47  "
  }), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, React.createElement("rect", {
    x: 71.2,
    y: 54.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 2
  }), React.createElement("rect", {
    x: 63.2,
    y: 55.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 50.2,
    y: 55.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.9,
    height: 0
  }), React.createElement("rect", {
    x: 56.2,
    y: 55.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 68.6,
    y: 54.3,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 61.6,
    y: 54.3,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 54.7,
    y: 54.3,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 63.2,
    y: 59.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 70.2,
    y: 59.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 0
  }), React.createElement("rect", {
    x: 50.2,
    y: 59.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.9,
    height: 0
  }), React.createElement("rect", {
    x: 56.2,
    y: 59.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 68.6,
    y: 58.1,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 61.6,
    y: 58.1,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 54.7,
    y: 58.1,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 50.2,
    y: 66.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.9,
    height: 0
  }), React.createElement("rect", {
    x: 70.2,
    y: 66.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 0
  }), React.createElement("rect", {
    x: 63.2,
    y: 66.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 58.2,
    y: 64.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.9
  }), React.createElement("rect", {
    x: 68.6,
    y: 65.1,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 60.1,
    y: 66.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.1,
    height: 0
  }), React.createElement("rect", {
    x: 53.1,
    y: 66.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.1,
    height: 0
  }), React.createElement("rect", {
    x: 63.2,
    y: 62.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 56.2,
    y: 62.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 71.2,
    y: 61.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 2
  }), React.createElement("rect", {
    x: 51.7,
    y: 61.4,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 2.9
  }), React.createElement("rect", {
    x: 68.6,
    y: 61.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 61.6,
    y: 61.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 53.1,
    y: 62.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.1,
    height: 0
  }), React.createElement("rect", {
    x: 33.4,
    y: 40,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 40.4,
    y: 40,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 47.4,
    y: 40,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 28.3,
    y: 40,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 0
  }), React.createElement("rect", {
    x: 44.3,
    y: 40,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.1,
    height: 0
  }), React.createElement("rect", {
    x: 30.3,
    y: 40,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.1,
    height: 0
  }), React.createElement("rect", {
    x: 37.3,
    y: 40,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.1,
    height: 0
  }), React.createElement("rect", {
    x: 47.4,
    y: 33,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 33.4,
    y: 33,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 28.3,
    y: 33,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 0
  }), React.createElement("rect", {
    x: 42.3,
    y: 31.1,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.9
  }), React.createElement("rect", {
    x: 29.3,
    y: 35.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 2
  }), React.createElement("rect", {
    x: 40.4,
    y: 36.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 49.3,
    y: 34.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.9
  }), React.createElement("rect", {
    x: 33.4,
    y: 36.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 44.3,
    y: 33,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.1,
    height: 0
  }), React.createElement("rect", {
    x: 45.8,
    y: 35.3,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 31.9,
    y: 31.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 31.9,
    y: 35.3,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 38.8,
    y: 31.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 38.9,
    y: 35.3,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.1
  }), React.createElement("rect", {
    x: 50.2,
    y: 69.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.9,
    height: 0
  }), React.createElement("rect", {
    x: 71.2,
    y: 68.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 2
  }), React.createElement("rect", {
    x: 56.2,
    y: 69.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.9,
    height: 0
  }), React.createElement("rect", {
    x: 65.1,
    y: 67.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 0,
    height: 3.9
  }), React.createElement("rect", {
    x: 67.1,
    y: 69.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.1,
    height: 0
  }), React.createElement("rect", {
    x: 60.1,
    y: 69.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.1,
    height: 0
  }), React.createElement("rect", {
    x: 53.1,
    y: 69.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.1,
    height: 0
  })));
};

export default __webpack_public_path__ + "static/media/collaboration.5d33fc3c.svg";
export { SvgCollaboration as ReactComponent };